import React from 'react';

const Features = () => {
  const features = [
    {
      img: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1026&q=80',
      title: 'Reduce el Dolor Muscular',
      description: 'Nuestra fórmula avanzada con mentol y carnosina actúa directamente sobre los músculos fatigados, proporcionando un alivio rápido y duradero.',
      aos: 'fade-right'
    },
    {
      img: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
      title: 'Mejora el Rendimiento',
      description: 'Usa LactiGo antes de entrenar para preparar tus músculos, reducir la acumulación de ácido láctico y entrenar más duro por más tiempo.',
      aos: 'fade-left'
    },
    {
      img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1220&q=80',
      title: 'Absorción Rápida',
      description: 'Su textura ligera en gel no deja residuos grasos y se absorbe en segundos, permitiéndote vestirte inmediatamente después de la aplicación.',
      aos: 'fade-right'
    }
  ];

  return (
    <section id="features" className="section">
      <div className="container">
        <h2 className="section-title">Beneficios de <span className="accent-color">LactiGo</span></h2>
        {features.map((feature, index) => (
          <div key={index} className="row align-items-center mb-5" data-aos={feature.aos}>
            <div className={`col-md-6 ${index % 2 !== 0 ? 'order-md-2' : ''}`}>
              <img src={feature.img} alt={feature.title} className="img-fluid rounded shadow-lg" />
            </div>
            <div className={`col-md-6 ${index % 2 !== 0 ? 'order-md-1' : ''}`}>
              <h3 className="mb-3">{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;